import { useEffect, useState } from "react";
import { api } from "../../lib/api";

const dayLabel = (iso) => new Date(iso).toLocaleDateString("en-GB", { weekday: "short", day: "2-digit", month: "short" });

// Date + 1-hour time-slot picker for the free site visit. Loads live availability.
export function SiteVisitSlots({ date, time, onChange }) {
  const [days, setDays] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get("/site-visit/slots")
      .then(r => setDays(r.data.days || []))
      .catch(() => setError("Couldn't load available times — please refresh."));
  }, []);

  const selected = days?.find(d => d.date === date);

  return (
    <div data-testid="sv-slots">
      <div className="label-eyebrow mb-2">1 · Pick a day</div>
      <div className="border border-[#E5E7EB] p-3 sm:p-4 max-h-[240px] overflow-y-auto grid grid-cols-2 sm:grid-cols-3 gap-2 bg-white">
        {!days && !error && <div className="col-span-full text-sm text-[#6B7280]">Loading available days…</div>}
        {error && <div className="col-span-full text-sm text-[#C0392B]" data-testid="sv-slots-error">{error}</div>}
        {days?.length === 0 && <div className="col-span-full text-sm text-[#6B7280]">No slots available right now — please call us.</div>}
        {days?.map(d => (
          <button key={d.date} type="button" data-testid={`sv-day-${d.date}`} onClick={() => onChange(d.date, "")}
            className={`px-1 py-2.5 text-xs border whitespace-nowrap ${date === d.date ? "bg-[#C79A3B] text-white border-[#C79A3B]" : "border-[#E5E7EB] hover:border-[#12263A]"}`}>
            {dayLabel(d.date)}
          </button>
        ))}
      </div>
      <div className="label-eyebrow mb-2 mt-5">2 · Pick a time <span className="normal-case tracking-normal font-medium text-[#6B7280]">(visits last about an hour)</span></div>
      {!selected ? (
        <div className="text-sm text-[#6B7280] border border-dashed border-[#E5E7EB] p-4 bg-white" data-testid="sv-time-placeholder">Choose a day above to see the times we can visit.</div>
      ) : (
        <div className="grid grid-cols-3 sm:grid-cols-4 gap-2" data-testid="sv-times">
          {selected.slots.map(t => (
            <button key={t} type="button" data-testid={`sv-time-${t.replace(":", "")}`} onClick={() => onChange(date, t)}
              className={`py-3 text-sm font-bold border ${time === t ? "bg-[#12263A] text-white border-[#12263A]" : "border-[#E5E7EB] bg-white hover:border-[#12263A]"}`}>
              {t}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
